export * as labService from './lab-service'
export * as lab from './lab'
